import { render, staticRenderFns } from "./article4.vue?vue&type=template&id=74b92e49&scoped=true"
import script from "./article4.vue?vue&type=script&lang=js"
export * from "./article4.vue?vue&type=script&lang=js"
import style0 from "./article4.vue?vue&type=style&index=0&id=74b92e49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b92e49",
  null
  
)

export default component.exports